// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SideBySide_wrapper__nCPZ4","side":"SideBySide_side__1OWCr"};